exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-validated-text-input__label{margin-bottom:10px}\n", ""]);

// exports
